import { useEffect, useRef } from 'react';
import apiClient from '@/api/axiosClient';
import { useAuthStore } from '@/stores/authStore';
import {
  fetchSupportChatSettings,
  isSupportChatMounted,
  mountSupportChat,
  supportChatNavigation,
} from './supportChat';

/**
 * Mounts BotableX's support chat for the signed-in user (see supportChat.ts). Renders nothing.
 * Mounted once at the app root so route changes never remount it.
 */
export function SupportChatMount(): null {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const tenantId = useAuthStore((s) => s.user?.tenantId);
  const wasAuthenticated = useRef(false);

  useEffect(() => {
    if (isAuthenticated && tenantId) {
      wasAuthenticated.current = true;
      let cancelled = false;
      void fetchSupportChatSettings(apiClient, 'admin-portal', tenantId).then((settings) => {
        if (!cancelled && settings) mountSupportChat(settings);
      });
      return () => {
        cancelled = true;
      };
    }
    // Logged out after being logged in: the loader cannot be torn down, so a mounted chat (identified
    // as the previous user) is removed by a full reload onto the login page.
    if (!isAuthenticated && wasAuthenticated.current && isSupportChatMounted()) {
      supportChatNavigation.reloadToLogin();
    }
    return undefined;
  }, [isAuthenticated, tenantId]);

  return null;
}
